import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Company } from '../../../../../types/company';
import { CompanyRequest } from '../../../../../requests/company.request';
import { storeCurrentCompanyId } from '../../../../../util/token.util';
import { Button, ButtonVariant } from '../../../../components/Button';
import { ActionModal } from '../../../../components/Modal';
import { TextInput } from '../../../../components/TextInput';
import { Routing } from '../../../../../util/routes.util';
import { useRequest } from '../../../../../requests/common/requestHook';

interface DuplicateCompanyModalProps {
  company: Company;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export default function DuplicateCompanyModal({ company, open, setOpen }: DuplicateCompanyModalProps) {
  const navigate = useNavigate();

  const [name, setName] = useState('');

  const valid = useMemo(() => !!name.trim(), [name]);

  const [duplicate, { loading }] = useRequest(CompanyRequest.duplicate);

  const handleDuplicate = async () => {
    if (!valid || loading) return;

    const duplicated = await duplicate({
      name: name.trim(),
      companyId: company.id,
    });

    if (duplicated) {
      storeCurrentCompanyId(duplicated.id);
      navigate(Routing.dashboard());
      window.location.reload();
    }
  };

  const handleClose = () => {
    if (loading) return;
    setOpen(false);
    setName('');
  };

  const footer = (
    <div className='grid grid-cols-2'>
      <div>
        <Button text={'Cancel'} variant={ButtonVariant.secondary} onClick={handleClose} disabled={loading} />
      </div>
      <div className='flex justify-end'>
        <Button text={'Duplicate'} onClick={handleDuplicate} disabled={!valid} loading={loading} />
      </div>
    </div>
  );

  return (
    <ActionModal open={open} setOpen={setOpen} title={'Duplicate company'} footer={footer}>
      <TextInput
        mandatory
        label={'Duplicated company name'}
        placeholder={'Name'}
        value={name}
        onChange={value => setName(value)}
      />
    </ActionModal>
  );
}
